import Tags from './tags'

export { default as Tag } from './tag'

export default Tags
